<template>
  <div>
    <b-table
      small
      hover
      striped
      :items="payments"
      :fields="fields"
    >
      <template v-slot:head()="data">
        <span class="table-header">{{ data.label }}</span>
      </template>
      <template v-slot:cell(created_at)="data">
        <div class="date">
          {{ data.value.substring(0, 10) }}
        </div>
      </template>
      <template v-slot:cell(Ds_Order)="data">
        <div class="order_no">
          {{ data.value }}
        </div>
        <div class="order_detail pt-1">
          - {{ $t('pages.payments.details.offer-publish', 'Offer publication') }}
        </div>
      </template>
      <template v-slot:cell(price)="data">
        <div class="price">
          {{ data.value }} €<span> + {{ $t('generic.vat', 'VAT') }}</span>
        </div>
        <div class="order_detail pt-1">
          {{ data.value }} €
        </div>
      </template>
      <template v-slot:cell(is_success)="data">
        <div :class="data.value ? 'status-success' : 'status-fail'">
          {{ data.value ? $t('pages.payments.success', 'Payment Successful') : $t('pages.payments.failed', 'Payment Failed') }}
        </div>
        <div
          class="mt-4 offer"
          @click="$router.push({ name: 'one-offer', params: { id: payments[data.index].offer_id }})"
        >
          <span class="offer_title">{{ $t('generic.offer', 'Offer') }}: </span>
          <span class="offer_id">{{ payments[data.index].offer_id }}</span>
        </div>
      </template>
    </b-table>
    <div v-if="payments.length === 0">
      {{ $t('pages.payments.no-payments', 'No payments yet') }}
    </div>
    <pagination
      v-if="paginationMeta"
      :data="paginationMeta"
      size="small"
      :limit="1"
      align="center"
      @pagination-change-page="getPayments"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      paginationMeta: null,
      payments: null,
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'created_at',
          label: this.$t('pages.payments.table.date', 'Date'),
          'class': 'date-cell'
        },
        {
          key: 'Ds_Order',
          label: this.$t('pages.payments.table.id_and_details', 'No. of payment and details'),
          'class': 'order-cell'
        },
        {
          key: 'price',
          label: this.$t('pages.payments.table.amount', 'Amount'),
        },
        {
          key: 'is_success',
          label: '',
          'class': 'status-cell'
        }
      ];
    }
  },
  mounted() {
    this.getPayments(1);
  },
  methods: {
    getPayments(page) {
      const config = {
        params: {
          page: page
        },
      };
      this.axios.get('/payment/me', config)
        .then( response => {
          this.payments = response.data.data;
          this.paginationMeta = response.data;
          window.scrollTo(0,0);
        })
        .catch( () => {
            this.$toastSomethingWentWrong();
          }
        );
    }
  },
}
</script>

<style lang="scss" scoped>
  .date {
    font-size: 0.8rem;
  }

  .order_no {
    font-size: 0.85rem;
    font-weight: 600;
    letter-spacing: 1px;
  }

  .price {
    font-size: 0.85rem;
    color: #c00;

    span {
      color: black;
    }
  }

  .order_detail {
    font-size: 0.9rem;
  }

  .status-fail {
    color: #c00;
    font-weight: 600;
    font-size: 0.85rem;
  }

  .status-success {
    color: rgb(0, 204, 0);
    font-weight: 600;
    font-size: 0.85rem;
  }

  .table-header {
    color: #f77518;
    font-size: 0.9rem;
  }

  .offer {
    font-size: 0.90rem;
    cursor: pointer;

    &:hover {
      font-weight: 600;
    }

    .offer_title {
      font-size: 0.8rem;
    }
  }
</style>

<style lang="scss">
  .date-cell {
    max-width: 50px;
  }

  .order-cell {
    height: 90px;
  }

  .status-cell {
    text-align: right;
  }

  .table thead th {
    border-bottom: 2px solid #f77518;
  }
</style>
